module.exports = __webpack_public_path__ + "static/media/2cff3acf-63a6-4ab6-aae2-02ec16fc0061.3e37fee7.JPG";